import { Stack } from '@src/common/components/Stack';
import { css } from '@src/common/styles/Styles';
import type { ComponentProps } from 'react';

export const PageContent = ({
  className,
  ...props
}: ComponentProps<typeof Stack>) => {
  return (
    <Stack
      direction="column"
      flex={1}
      className={`${pageContent} ${className}`}
      {...props}
    />
  );
};

const pageContent = css({
  overflow: 'auto',
  flex: 1,
  flexDirection: 'column',
  height: '100vh',
});
